import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-h3" }
const _hoisted_2 = { class: "text-body1 q-py-sm" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "q-pt-sm row items-center" }
const _hoisted_5 = { class: "q-ml-sm col" }
const _hoisted_6 = ["innerHTML"]

import { useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxBtnOutline from "src/components/button/SfxBtnOutline.vue"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { computed, ref } from "vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogCheckBox',
  props: {
  title: {
    type: String,
    required: true,
  },

  content: {
    type: String,
    required: true,
  },

  html: {
    type: Boolean,
    default: false,
  },

  label: {
    type: String,
  },

  persistent: {
    type: Boolean,
    default: false,
  },

  classes: {
    type: String,
  },

  width: {
    type: Number,
  },

  confirmButtonText: {
    type: String,
  },

  rejectButtonText: {
    type: String,
  },

  confirmButtonClasses: {
    type: String,
  },

  rejectButtonClasses: {
    type: String,
  },
},
  emits: [...useDialogPluginComponent.emits],
  setup(__props) {

const props = __props



//endregion

//region Variables

const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()

const checkboxVal = ref(false)

const dialogWidthStyle = computed(() => {
  return props.width ? `width: ${props.width}px;` : ""
})

//endregion

//region Function

function handleDialogOk() {
  onDialogOK(checkboxVal.value)
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    persistent: props.persistent,
    onHide: _unref(onDialogHide)
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, {
        class: _normalizeClass(["q-dialog-plugin", props.classes]),
        style: _normalizeStyle(dialogWidthStyle.value)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, _toDisplayString(__props.title), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (props.html)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      innerHTML: props.content
                    }, null, 8, _hoisted_3))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(props.content), 1)
                    ], 64))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_q_checkbox, {
                  size: "56px",
                  class: "sfx-checkbox",
                  "checked-icon": _unref(Icons).ACCEPT,
                  modelValue: checkboxVal.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checkboxVal).value = $event))
                }, null, 8, ["checked-icon", "modelValue"]),
                _createElementVNode("div", _hoisted_5, [
                  (props.html)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        innerHTML: props.label
                      }, null, 8, _hoisted_6))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(props.label), 1)
                      ], 64))
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, { class: "q-px-md q-pb-md q-pt-sm" }, {
            default: _withCtx(() => [
              _createVNode(SfxBtnOutline, {
                label: __props.rejectButtonText,
                class: _normalizeClass([__props.rejectButtonClasses, "col q-mr-sm"]),
                onClick: _unref(onDialogCancel)
              }, null, 8, ["label", "class", "onClick"]),
              _createVNode(SfxBtn, {
                label: __props.confirmButtonText,
                class: _normalizeClass([__props.confirmButtonClasses, "col"]),
                onClick: handleDialogOk
              }, null, 8, ["label", "class"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class", "style"])
    ]),
    _: 1
  }, 8, ["persistent", "onHide"]))
}
}

})